<template>
  <div :class="[schema.styleClasses, getSelectedDEV && 'dev-selected-component']" v-if="schema.visible">
    <v-expansion-panels
      v-bind="schema.attributes"
      v-model="showCollapse"
      :class="['column-group', schema.fixed && 'expansion-fixed', schema.flat && 'column-group--not-border']"
    >
      <v-expansion-panel>
        <v-expansion-panel-header
          :class="[schema.borderClass, schema.attributes.class]"
          v-if="schema.header"
          @contextmenu="selectComponentDEV($event, schema.model)"
        >
          <v-icon v-if="schema.appendIcon" v-bind="schema.appendIcon.attributesIcon">{{ schema.appendIcon.icon }}</v-icon>
          {{ schema.name }}
          <template v-slot:actions>
            <v-icon :color="schema.attributes.bulletColor ? schema.attributes.bulletColor : 'primary'">$vuetify.icons.expand</v-icon>
          </template>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <vue-form-generator
            tag="div"
            :schema="schema"
            :model="model"
            :options="{ mode, page, tab, step }"
            v-if="(model && Object.keys(model).length) || config.DEV_MODULE"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  name: 'I4proColumnGroup',
  mixins: [devComponentMixin],

  mounted() {
    if ('expand' in this.schema) {
      this.showCollapse = this.schema.expand === false ? undefined : 0;
    }
  },

  props: {
    schema: { type: Object, default: () => ({}) },
    mode: { type: String, default: undefined },
    page: { type: String, default: null },
    tab: { type: Number, default: null },
    step: { type: Number, default: null }
  },

  computed: {
    model() {
      return this.$store.getters['page/model']({ page: this.page, mode: this.mode });
    },

    config() {
      return this.$store.getters['authentication/getConfig'];
    },

    showCollapse: {
      get() {
        if ('expand' in this.schema) {
          return this.schema.expand === false ? undefined : 0;
        }

        return 0;
      },
      set(param) {
        this.schema.expand = param === 0 ? true : false;
      }
    }
  }
};
</script>
